import React, { useEffect } from "react"
import { COPY_STRINGS } from "../../../../constants/translatedCopy"
import { delay } from "../../../../services/util"
import { amiraGestures } from "../../../Coach/GesturedSpeech"
import { studentInProductHelpLinks } from "../../../../constants/helpLinks"
import StudentInstruction from '../../Components/StudentInstruction'
import RaiseHand from '../../Components/PreCheckIllustrations/RaiseHand'
import { GetBrandedTutorName } from "../../../../services/BrandingService"
import { getCopyByGradeband } from "../../../../services/ThemingService"

export default React.memo(function InstructToFixPermission(props) {

    const { speechProps, toggleReaderContainer } = props

    useEffect(() => {
        toggleReaderContainer()
        speechProps.abortDance()
        const speechPattern = async () => {
            speechProps.playDance({
                gesture: amiraGestures.Playful_nomouth,
            })

            const studentChecks = getCopyByGradeband(COPY_STRINGS, 'student_checks');

            await speechProps.speakWithPromise({
                textToSpeak: studentChecks.student_hardware_denied,
            })
            speechProps.abortDance();
            speechProps.playDance({
                gesture: amiraGestures.PointingWithChalk
            })
            await speechProps.speakWithPromise({
                textToSpeak: studentChecks.student_hardware_denied_two,
            })
            speechProps.abortDance();
          }
        speechProps.abortSpeech(speechPattern)

        return () => {
            toggleReaderContainer()
        }
    }, [])

    return <div>
        <StudentInstruction>
            <RaiseHand/>
            <p>{GetBrandedTutorName()} needs access to the microphone to listen to your student read. Please follow the instructions at this <a target="_blank" rel="noopener noreferrer" href={studentInProductHelpLinks.enableMicrophoneGeneral}>microphone help link</a> to enable microphone access.</p>
        </StudentInstruction>
    </div>

})